



















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {棚卸差数在庫場所型, 棚卸差数在庫場所結果型, 棚卸差数型, 棚卸差数検索依頼型, 棚卸差数棚卸年月日型, 棚卸差数結果型, 棚卸差数検索条件型バリデータ一覧} from '@/type/inquire/item';
import moment from 'moment';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {loginModule} from '@/store/authentication/login';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {ValidationResult} from '@/type/validation/result';
import UsageClassSelector from '@/components/item/UsageClassSelector.vue';
import {progress} from '@/script/progress';
import {InventoryDiffApi} from '@/infrastructure/api/inquire/inventoryDiffApi';
import {StandardInventoryDiffApi} from '@/infrastructure/api/inquire/standardInventoryDiffApi';
import {GoryoukakuInventoryDiffApi} from '@/infrastructure/api/custom/goryoukaku/inquire/goryoukakuInventoryDiffApi';

@Component({
  components: {
    ButtonPanel,
    IconButton,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
    UsageClassSelector,
  },
  filters: {
    日付のフォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class InventoryDiff extends Vue {
  // data
  在庫場所一覧: 棚卸差数在庫場所型[] = [];
  棚卸年月日一覧: 棚卸差数棚卸年月日型[] = [];
  アラートメッセージ: string[] | string | null = null;

  棚卸差数検索依頼初期値: 棚卸差数検索依頼型 = {
    部署コード: '',
    検索棚卸年月日: new Date(),
    表示対象差数有無区分: '差数あり',
    商品名カナ検索文字列: '',
    メーカー名検索文字列: '',
    検索対象商品区分: null,
    検索対象使用区分: null,
    棚名検索文字列: '',
    棚番号検索文字列: '',
    並順区分検索条件: '棚名棚番号',
  };
  棚卸差数検索依頼: 棚卸差数検索依頼型 = {...this.棚卸差数検索依頼初期値};
  バリデーション結果: ValidationResult = new ValidationResult(棚卸差数検索条件型バリデータ一覧);

  棚卸差数一覧: 棚卸差数型[] = [];

  選択棚卸差数: 棚卸差数型 | null = null;
  選択行: number = 0;

  api!: InventoryDiffApi;

  // computed
  get 棚卸有効期限を表示する(): boolean {
    return loginModule.棚卸有効期限を表示する;
  }

  get 棚卸有効期限を表示しない(): boolean {
    return loginModule.棚卸有効期限を表示しない;
  }

  get 譲受カラムを表示する(): boolean {
    return loginModule.譲渡譲受を利用する;
  }

  get 函館五稜郭病院仕様である(): boolean {
    return loginModule.函館五稜郭病院仕様である;
  }

  get 表示件数(): number {
    return this.棚卸差数一覧.length;
  }

  // watched properties
  @Watch('棚卸差数検索依頼.部署コード')
  在庫場所変更(val: string, oldVal: string) {
    if (oldVal !== '') {
      progress(this.棚卸年月日一覧取得);
    }
  }

  // methods
  async 初期処理(): Promise<void> {
    await progress(this.初期化処理);
  }

  async 初期化処理(): Promise<void> {
    await this.在庫場所一覧取得();
    await this.棚卸年月日一覧取得();
    await this.棚卸差数一覧取得();
  }

  async 在庫場所一覧取得(): Promise<void> {

    const 検索結果 = await this.api.棚卸差数在庫場所一覧を取得する()
      .catch((error: any) => {
        this.在庫場所一覧 = [];
        this.アラートメッセージ =  '該当するデータがありません。';
        this.$modal.show('アラートダイアログ');
        return;
      });

    if (this.アラートメッセージ != null) return;

    const 在庫場所一覧取得結果 = 検索結果 as 棚卸差数在庫場所結果型;
    this.在庫場所一覧 = 在庫場所一覧取得結果.棚卸差数在庫場所一覧 as 棚卸差数在庫場所型[];
    const 所属在庫場所 = 在庫場所一覧取得結果.所属在庫場所 as 棚卸差数在庫場所型;
    for (const 棚卸差数在庫場所 of this.在庫場所一覧) {
      if (棚卸差数在庫場所.部署コード === 所属在庫場所.部署コード) {
        this.棚卸差数検索依頼.部署コード = 所属在庫場所.部署コード;
        return;
      }
    }
    this.棚卸差数検索依頼.部署コード = this.在庫場所一覧[0].部署コード;
  }

  showAlert() {
    this.$modal.show('アラートダイアログ');
  }

  async 棚卸年月日一覧取得(): Promise<void> {
    if (this.在庫場所一覧.length === 0) {
      return;
    }
    const 棚卸年月日一覧取得結果 = await this.api.棚卸差数棚卸年月日一覧を取得する(this.棚卸差数検索依頼.部署コード)
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.showAlert();
        this.棚卸年月日一覧 = [];
        return;
      });

    this.棚卸年月日一覧 = 棚卸年月日一覧取得結果 as 棚卸差数棚卸年月日型[];
    this.棚卸差数検索依頼.検索棚卸年月日 = this.棚卸年月日一覧[0].棚卸日;
  }

  async 検索開始(): Promise<void> {
    await progress(this.棚卸差数一覧取得);
  }

  async 棚卸差数一覧取得(): Promise<void> {
    if (this.在庫場所一覧.length === 0) {
      return;
    }

    if (this.バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.バリデーション結果.getMessages();
      this.showAlert();
      return;
    }

    const 検索結果 = await this.api.棚卸差数一覧を取得する(this.棚卸差数検索依頼)
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.showAlert();
        this.棚卸差数一覧 = [];
        this.クリア();
        return;
      });

    const 棚卸差数一覧取得結果 = 検索結果 as 棚卸差数結果型;
    if (棚卸差数一覧取得結果) {
      this.棚卸差数一覧 = 棚卸差数一覧取得結果.棚卸差数一覧 as 棚卸差数型[];
    }
    this.選択行 = 0;

    if (棚卸差数一覧取得結果.アラートメッセージ) {
      this.アラートメッセージ = 棚卸差数一覧取得結果.アラートメッセージ;
      this.showAlert();
    }
  }

  検索開始ボタン活性確認(): boolean {
    return this.在庫場所一覧.length > 0;
  }

  リストから選択する(選択棚卸差数: 棚卸差数型) {
    this.選択棚卸差数 = 選択棚卸差数;
    this.選択行 = this.棚卸差数一覧.indexOf(選択棚卸差数) + 1;
  }

  Excel出力確認ダイアログを開く(): void {
    this.$modal.show('確認ダイアログ');
  }

  確認ダイアログを閉じる() {
    this.$modal.hide('確認ダイアログ');
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.在庫場所一覧.length === 0) {
      return;
    }

    if (this.バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.バリデーション結果.getMessages();
      this.showAlert();
      return;
    }
    this.Excel出力確認ダイアログを開く();
  }

  async Excelファイルを出力する(): Promise<void> {
    this.確認ダイアログを閉じる();
    await progress(this.棚卸差数一覧表の出力);
  }

  async 棚卸差数一覧表の出力(): Promise<void> {
    await this.api.棚卸差数一覧表を出力する('棚卸差数一覧.xlsx', this.棚卸差数検索依頼)
            .catch((error: any) => {
              this.アラートメッセージ = error.data.message;
              this.showAlert();
              return;
            });
  }

  クリア(): void {
    this.選択行 = 0;
  }

  // lifecycle hooks
  mounted(): void {
    if (this.函館五稜郭病院仕様である) {
      this.api = new GoryoukakuInventoryDiffApi();
    } else {
      this.api = new StandardInventoryDiffApi();
    }

    this.初期処理();
  }

  private beforeUpdate() {
    this.バリデーション結果.validate(this.棚卸差数検索依頼);
  }

}
